import React, { Fragment, useState, useRef, useEffect } from 'react'
import Header from '../Header';
import Footer from '../Footer';
// import SubNavigation from '../OurServices/SubNav.jsx';
import Slider from 'react-slick';
import HostingChoosing from './HostingChoosing.jsx'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../slider.css';
import { Link } from 'react-router-dom';
const WebHosting = () => {
    useEffect(() => {
        document.title = 'Web Hosting Services | KumbhaaTech Solutions';
        return () => {
            document.title = 'leading software company - KumbhaaTech Solutions';
        };
    }, []);

    const [activeIndex, setActiveIndex] = useState(0);

    const sliderRef = useRef(null);


    const settings = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true, // Enable auto slide
        autoplaySpeed: 3000, // 3 seconds per slide
        beforeChange: (current, next) => {
            setActiveIndex(next);
        },
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };


    const cards = [
        {
            image: "assets/images/icons/cost-effective.svg",
            heading: "Cost-Effectiveness",
            description: "Affordable web hosting services provide high-quality hosting solutions at a low cost, making it accessible for businesses and individuals with limited budgets.",

        },
        {
            image: "assets/images/icons/scalability.svg",
            heading: "Scalability",
            description: "Affordable hosting plans offer scalable options, allowing users to upgrade their resources as their website traffic and content grow without incurring significant additional costs.",

        },
        {
            image: "assets/images/icons/flexibility.svg",
            heading: "Reliability and Uptime ",
            description: "Despite their low cost, affordable web hosting services provide reliable performance and high uptime, ensuring that websites remain accessible to users at all times.",

        },
        {
            image: "assets/images/icons/support.svg",
            heading: "Customer Support",
            description: "Affordable web hosting services often include customer support to assist users with technical issues, ensuring a smooth and hassle-free hosting experience.",

        }
    ];

    const handlePrevious = () => {
        sliderRef.current.slickPrev();
    };

    const handleNext = () => {
        sliderRef.current.slickNext();
    };


    return (
        <Fragment>
            <Header />

            <div className="custom-banner-1">
                <div className="container">
                    <div className="custom-banner-content">
                        <div className="left-content">
                            <h1>
                                <span className='g-c-b'>Web Hosting Services</span> at the Best Price
                            </h1>
                        </div>
                        <div className="right-content">
                            <hr
                                className="orange-line"
                                style={{ height: '5px', width: '50px', background: '#00a798', opacity: '1' }}
                            />
                            <p>
                                Securing your online identity is crucial, and Kumbhaatech Solutions specializes in providing reliable and affordable Web Hosting services.Whether you're starting a new venture or looking to enhance your current online presence, we offer solutions tailored to meet your needs. Explore our range of domain names to find the perfect match for your business or personal website.
                            </p>
                            <Link className="text-white" to="/kumbhatech-affordable-website-design-chennai">
                                Know More <i className="fa fa-angle-right abt-btn" aria-hidden="true"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className='breadcrumb'>
                <div className='container'>
                    <div class="">
                        <Link href="/">Home</Link>
                        <Link href="/services">Services</Link>
                        <span>Web Hosting</span>
                    </div>
                </div></div>
            <section className="web-development-container">
                <div class="position-relative">
                    <div className="animation-home-about-green animation-round-bg top-right-web"></div>
                    <div class="animation-home-about-green animation-round-bg bottom-left"></div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className=" col-lg-8 web-2-hide">
                            <div className="image-container-web ">
                                <img src="assets/banners/hoat-t.webp" alt="Digital Marketing" loading='lazy' decoding='async' />
                                {/* <a href="https://www.freepik.com/free-photo/html-css-collage-concept-with-person_36295457.htm#fromView=search&page=1&position=10&uuid=45d7d1b2-7ddd-44e7-b0fb-5f55ac5a4d67">Image by freepik</a> */}
                            </div>
                        </div>
                        <div className="web-heading col-md-8">
                            <h2 >Unlocking the Power of <span className='o-c-b-w-b'>Affordable Web Hosting</span>: Why KumbhaaTech is Your Best Choice.</h2>
                        </div>
                    </div>
                    <div className="row  w-container" >
                        <div className="col-lg-5 web-1-hide">
                            <div className="image-container-web">
                                <img src="assets/banners/hoat-t.webp" alt="we hosting" loading='lazy' decoding='async' />
                                {/* <a href="https://www.freepik.com/free-photo/html-css-collage-concept-with-person_36295457.htm#fromView=search&page=1&position=10&uuid=45d7d1b2-7ddd-44e7-b0fb-5f55ac5a4d67">Image by freepik</a> */}
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-10">
                            <div className="web-content">
                                <p className='p-20'>In the digital age, having a robust online presence is crucial for businesses and individuals alike. A key component of establishing this presence is reliable web hosting. However, finding a web hosting service that is both high-quality and affordable can be challenging.</p>
                                <p>At KumbhaaTech, we understand the importance of cost-effective solutions that don't compromise on performance. That's why we offer affordable web hosting services designed to meet the diverse needs of our clients.</p>
                                <Link to='/kumbhatech-affordable-website-design-chennai' className='text-black'>Know More <i className="fa fa-angle-right abt-btn-b" aria-hidden="true"></i></Link>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="info-section" >
                <div class="position-relative">

                    <div class="animation-home-about-green animation-round-bg top-right-web"></div>

                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row section-heading" >
                                <div className="col-md-8 col-lg-6">
                                    <h2 className="">
                                        The Purpose of <span className='g-c-b'>Web</span>
                                        <span className='g-c-b'> Hosting</span> Services
                                    </h2>
                                </div>
                                <div className="col-lg-6 col-md-10">
                                    <p className="section-description">
                                        Web hosting services provide the infrastructure needed to keep your website live, fast, and secure. With reliable uptime and performance, hosting ensures your visitors have a seamless online experience every time.
                                    </p>
                                </div>
                            </div>

                            <div className='info-card-container'>
                                <div className="info-card">
                                    <div className="info-icon">
                                        <img src="assets/images/icons/Websites Accessible-g.svg" alt="Making Websites Accessible" loading='lazy' decoding='async' />
                                    </div>
                                    <div className="info-card-box">
                                        <h3>Making Websites Accessible</h3>
                                        <p>The primary purpose of web hosting is to make websites accessible to users on the internet. Hosting services provide the necessary infrastructure to store and deliver website content to visitors.</p>
                                    </div>
                                </div>
                                <div className="info-card">
                                    <div className="info-icon">
                                        <img src="assets/images/icons/Performance & Reliability.svg" alt="Ensuring Performance & Reliability" loading='lazy' decoding='async' />
                                    </div>
                                    <div className="info-card-box">
                                        <h3>Ensuring Performance & Reliability</h3>
                                        <p>Web hosting services ensure that websites perform well and remain accessible 24/7, providing reliable uptime and fast loading speeds.</p>
                                    </div>
                                </div>
                                <div className="info-card">
                                    <div className="info-icon">
                                        <img src="assets/images/icons/Website Growth.svg" alt="Supporting Website Growth" loading='lazy' decoding='async' />
                                    </div>
                                    <div className="info-card-box">
                                        <h3>Supporting Website Growth</h3>
                                        <p>Affordable web hosting allows businesses and individuals to scale their online presence as their website traffic and content grow, providing flexible and scalable solutions.</p>
                                    </div>
                                </div>
                                <div className="info-card">
                                    <div className="info-icon">
                                        <img src="assets/images/icons/security-g.svg" alt="Providing Security" loading='lazy' decoding='async' />
                                    </div>
                                    <div className="info-card-box">
                                        <h3>Providing Security</h3>
                                        <p>Web hosting services offer security features such as SSL certificates, firewalls, and regular backups to protect websites from cyber threats and data loss.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section class="home-about-section " id='understanding'>

                <div class="container">
                    <div className="row">
                        <div class="home-about-container  " >
                            <div className='col-lg-5'>
                                <div className='second-about-mask-image '>
                                    <img src="assets/banners/hoat-c.webp" alt="Understanding Website Design and Development" loading='lazy' decoding='async' />
                                </div>
                            </div>
                            <div className='col-lg-6 col-md-10 '>
                                <div className='home-about-container-inside '>
                                    <div className='web-heading '>
                                        <h2> Kumbhatech Solutions: <span className='o-c-b-w-b '>Your Partner in Affordable</span> Web Hosting</h2>

                                    </div>
                                    <p className='p_20'>At Kumbhatech Solutions, we understand the importance of reliable web hosting for your online success. Our affordable hosting services provide the perfect balance of performance, security, and support, ensuring your website is always accessible to your audience. Whether you're starting a new site or looking to optimize an existing one, we've got you covered.</p>
                                    <br />
                                    <p>Web hosting is a service that allows individuals and organizations to make their websites accessible via the internet. Web hosting companies provide the technology and server space needed to store website files and make them available to online users. Affordable web hosting refers to hosting services that offer reliable performance and features at a low cost.</p>

                                </div>
                            </div>
                        </div>
                    </div></div>
            </section>



            <section className='benefit-slider-section' id='benefits'>
                <div className="container">
                    <div className='row b-heading-container'>
                        <div className="col-lg-7 col-md-9">
                            <div className="benefit-heading">
                                <h2> Affordable<span className='o-c-b-w-b '> Web Hosting</span> Service</h2>

                            </div>
                        </div>
                        <div className='col-md-3 col-lg-5 green'>
                            <div className="bottom-container">
                                <div className="custom-arrows">
                                    <button className="custom-arrow" onClick={handlePrevious}>
                                        &#8249;
                                    </button>
                                    <button className="custom-arrow" onClick={handleNext}>
                                        &#8250;
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="slider-container digital">
                                <Slider ref={sliderRef} {...settings}>
                                    {cards.map((card, index) => (
                                        <div className={`slider-card ${index === activeIndex ? 'active' : ''}`} key={index}>
                                            <div className="slider-image">
                                                <img
                                                    src={card.image}
                                                    alt={card.heading}

                                                    loading='lazy'
                                                    decoding='async'
                                                />
                                            </div>
                                            <h4 className="h-hide">{card.heading}</h4>
                                            <div className={`c-conetnt ${index === activeIndex ? 'show' : ''}`}>
                                                <h4 className="card-heading">{card.heading}</h4>
                                                <p className="card-description">
                                                    {card.description}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>


                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <section className='does-work'>
                <div className="container">
                    <div className="col-lg-9 web-heading-green">
                        <h2 className='text-white'>Importance of Cheap<span className='g-c-b'> Web Hosting</span></h2></div>

                    <div className="overflow-hidden does_wrapper">

                        <div className='position-relative'>
                            <div className="scroll-container">
                                <div className='how_does_heading'>
                                    KUMBHA
                                </div>
                                <div className="how_container">
                                    <div className="col-lg-6 z_how_number">
                                        <div className="z_how_number_wrapper">
                                            <span className='highlight_num'>01</span>
                                            <h3>Accessibility in Cheap Hosting</h3>
                                            <p>Cheap hosting allows businesses, especially startups, to create an online presence without high costs, with easy-to-use tools and scalable options for growth.</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 z_how_number">
                                        <div className="z_how_number_wrapper">
                                            <span className='highlight_num'>02</span>
                                            <h3>24/7 Customer Support</h3>
                                            <p>Affordable hosting often includes round-the-clock support, ensuring websites stay online and issues are resolved quickly.</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 z_how_number">
                                        <div className="z_how_number_wrapper">
                                            <span className='highlight_num'>03</span>
                                            <h3>Quality at Lower Costs</h3>
                                            <p>Many cheap hosts provide reliable services with modern tech like SSDs, ensuring high uptime and secure websites without hefty prices.</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 z_how_number">
                                        <div className="z_how_number_wrapper">
                                            <span className='highlight_num'>04</span>
                                            <h3>Fast Website Performance</h3>
                                            <p>Technologies like SSD storage and caching speed up websites, improving user experience and engagement.</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 z_how_number">
                                        <div className="z_how_number_wrapper">
                                            <span className='highlight_num'>05</span>
                                            <h3>Scalable Plans</h3>
                                            <p>Cheap hosting offers flexible plans that can grow with your business, from basic to more advanced options as your needs increase.</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 z_how_number">
                                        <div className="z_how_number_wrapper">
                                            <span className='highlight_num'>06</span>
                                            <h3>Customizable Solutions</h3>
                                            <p>Affordable hosting lets businesses choose the right tools (like CMS or e-commerce platforms) to meet specific needs.</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 z_how_number">
                                        <div className="z_how_number_wrapper">
                                            <span className='highlight_num'>07</span>
                                            <h3>Competitive Advantage</h3>
                                            <p>By saving on hosting, businesses can invest in other areas like marketing, gaining an edge over competitors.</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 z_how_number">
                                        <div className="z_how_number_wrapper">
                                            <span className='highlight_num'>08</span>
                                            <h3>Agility in Response</h3>
                                            <p>With cost-effective hosting, businesses can quickly adapt to market changes, launching new products or adjusting marketing strategies.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="apply-now" id="approch" style={{ background: 'white' }}>
                <div className='apply-image-container'>
                    <div className="container">
                        <div className="row ac-space" >
                            <div className='col-lg-7 col-md-10'>
                                <h2 className='ap-accordion-heading'><span className='o-c-b-w-b'>KumbhaTech’s </span>Approach to Affordable Web Hosting</h2>

                            </div>
                            <div className="col-lg-5 col-md-9">
                                <p className='ap-accordion-description'>At KumbhaaTech, we understand the importance of cost-effective solutions that deliver results. Our approach to affordable web hosting focuses on:</p>
                            </div>
                        </div>
                        <div className="row l-t" >

                            <HostingChoosing />
                            <div className="col-lg-6 p-i-3">
                                <img src="assets/banners/hoste-b.webp" alt="KumbhaTech’s Approach " loading='lazy' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className='fixed-bacground-section'>
                <div className="fixed-background-5">
                    <div className="fixed-background-content">
                        <div className="fixed-background-content-inside">
                            <h2>Ready to Secure Your Online Identity?</h2>
                            <p>Ensure your online presence starts with the right WebHosting. Contact Kumbhatech Solutions for WebHosting services. We provide a seamless process to help you secure your desired domain quickly and affordably. Let us assist you in establishing a strong online identity that aligns with your business goals!.</p>
                            <br />
                            <Link to='/kumbhatech-affordable-website-design-chennai' className='benift-btn'>Connect With Us</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="conclusion" id='Conclusion'>
                <div className="container">
                    <div className='row'>
                        <div className='col-lg-12'>
                            <h2 className='conclusion-heading'>conclusion</h2>
                        </div>
                        <div className="col-lg-6">
                            <div className="fist-conclusion-content">
                                <p>In conclusion, affordable web hosting plays a crucial role in enabling businesses and individuals to establish and maintain their online presence. From making websites accessible and ensuring reliable performance to providing security and scalability, web hosting services are essential for success in the digital age. Cheap web hosting services offer a cost-effective solution, ensuring accessibility, affordability, and quality without compromise. Contact KumbhaaTech today to learn more about our affordable web hosting services and take the first step towards a robust online presence.</p>
                            </div>
                        </div>
                        <div className="col-lg-6">

                            <div className="second-conclusion-content">
                                <p>By choosing KumbhaaTech, you're partnering with a trusted web hosting provider that prioritizes affordability, quality, and reliability. Let us help you unlock the power of affordable web hosting and achieve your online goals with confidence.</p>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='news-letter'>
                <div className="news-letter-container">

                    <div className="container">
                        <div className="row">

                            <div className="col-lg-6">
                                <div>
                                    <h4>Get Your Domain Today!</h4>
                                    <p>Ready to claim your online presence? Contact us now to register your domain with ease. Let Kumbhatech Solutions be your trusted partner in building a strong online foundation for your business!.</p>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className='subscribe-btnbox'>
                                    <Link to='/kumbhatech-affordable-website-design-chennai'>Connect With Us <span>+</span></Link></div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <Footer />
        </Fragment>
    )
}

export default WebHosting;
/* <a href="https://www.freepik.com/free-photo/corporate-management-strategy-solution-branding-concept_28096443.htm#fromView=search&page=1&position=0&uuid=ff2715e4-6f8d-4035-9ed7-c0aeecfb5dd2">Image by rawpixel.com on Freepik</a>online */
/* <a href="https://www.freepik.com/free-photo/young-woman-working-laptop-isolated-white-background_8907406.htm#fromView=search&page=1&position=19&uuid=60ca384b-cb1a-41d2-af00-7881005c1521">Image by diana.grytsku on Freepik</a> profess */